<script>
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: { PhxsgButton },

  props: {
    filterId: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
<template>
  <phxsg-button size="sm" :icon="{ end: { id: 'close', label: $t('Button.remove') } }">
    {{ label }}
  </phxsg-button>
</template>
